import { AxiosError, AxiosHeaders, InternalAxiosRequestConfig } from 'axios';

export function toAxiosError<T>(
  status: number,
  statusText: string,
  data: T,
): AxiosError<T> {
  const config: InternalAxiosRequestConfig = { headers: new AxiosHeaders() };

  return new AxiosError<T>(
    `Request failed with status code ${status}`,
    status.toString(),
    config,
    {},
    { data, status, statusText, headers: new AxiosHeaders(), config },
  );
}
